import { apiUtils } from '../utils/apiUtils'

const jsonHeaders = { 'Content-Type': 'application/json' }

export default {
  upsert: function (code, employee) {
    return fetch(apiUtils.integrationEnroll + '/employees/' + code, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(employee)
    }).then((res) => {
      if (!res.ok) {
        throw new Error('Erreur lors de la sauvegarde employe')
      }
      return res
    })
  },
  remove: function (code, employee) {
    const employeeId = employee.idemployees || employee.idEmployees
    if (!employeeId) {
      return Promise.resolve()
    }
    return fetch(apiUtils.integrationEnroll + '/employees/' + code + '?employeeid=' + encodeURIComponent(employeeId), {
      method: 'DELETE',
      headers: jsonHeaders,
      body: JSON.stringify({ idemployees: employeeId })
    }).then((res) => {
      if (!res.ok) {
        throw new Error('Erreur lors de la suppression employe')
      }
      return res
    })
  }
}
